import { ReactNode } from "react-markdown/lib/react-markdown";

const DefaultSpacer = ({
  type,
  color,
  textColor,
  children,
  route,
}: {
  type: string;
  color: any;
  textColor: any;
  children: ReactNode;
  route?: string;
}) => {
  return (
    <div style={{ background: color.hex, color: textColor.hex }}>
      {children}
    </div>
  );
};

export default DefaultSpacer;
